import { render, staticRenderFns } from "./MarketplaceContractLayout.vue?vue&type=template&id=b2b3eb24&scoped=true&"
import script from "./MarketplaceContractLayout.vue?vue&type=script&lang=js&"
export * from "./MarketplaceContractLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b3eb24",
  null
  
)

export default component.exports